import * as yup from 'yup';

export type TValues = {
  reason: string;
};

export const validationSchema = yup.object({
  reason: yup.string().required('Обязательное поле.'),
});
